import { observable, action } from 'mobx';
import { clone } from 'utils';
import executionReportingAdapter from 'adapters/ExecutionReportingAdapter';

class ExecutionReportingStore {
  @observable publishers = [];
  @observable reports = [];
  @observable isLoadingPublisers = false;
  @observable isLoadingReports = false;

  @action
  loadPublishers() {
    this.isLoadingPublisers = true;
    return executionReportingAdapter
      .loadPublishers()
      .then(
        action((publishers) => {
          this.isLoadingPublisers = false;
          this.publishers = clone(publishers);
          return publishers;
        })
      )
      .catch(
        action(() => {
          this.isLoadingPublisers = false;
        })
      );
  }

  @action
  loadReports(params) {
    this.isLoadingReports = true;
    return executionReportingAdapter
      .loadReports(params)
      .then(
        action((reports) => {
          this.isLoadingReports = false;
          this.reports = clone(reports);
          return reports;
        })
      )
      .catch(
        action(() => {
          this.isLoadingReports = false;
        })
      );
  }

}

const instance = new ExecutionReportingStore();

export default instance;


// WEBPACK FOOTER //
// ./src/stores/ExecutionReportingStore.js